import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';
import uiSelectors from 'selectors/ui';

export default function openChat() {
  return (dispatch, getState) => {
    const state = getState();

    if (uiSelectors.getCurrentLocation(state.ui) === uiEnums.LOCATIONS.OFFICE_HOURS) {
      dispatch(uiEvents.navigateReplace(uiEnums.LOCATIONS.CHAT));
    }
  };
}
